/* eslint-disable @typescript-eslint/no-explicit-any */

import { TUserTrackingData, TTrackingPageData } from '../../types';

export interface ITrackingReducerState {
  user: TUserTrackingData;
  page: TTrackingPageData;
}

export interface ITrackingReducerAction {
  type: ETrackingReducerActions;
  payload: {
    // Неизвестно, какими будут данные
    // tslint:disable-next-line
    [key: string]: any;
  };
}

export enum ETrackingReducerActions {
  SetTrackingState = 'TrackingReducer / SetTrackingState',
}
